import { Tag } from "antd";

export const FinalizadoTag = ({ icon, text = null, ...restProps }) => {
  return (
    <Tag color="#52C41A" {...restProps}>
      {icon} {text === null ? "Finalizado" : text}
    </Tag>
  );
};
